'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    /********
    	description：将json对象转成url参数
    	paramter：
    		data:【必需】需转换的JSON对象
    	version:1.0.0
    	data:2019/08/26
    	changeContent:基础版(cuishuai)
    ********/
    parseParams: function parseParams(data) {
        var patter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "&";

        try {
            var tempArr = [];
            for (var i in data) {
                var key = encodeURIComponent(i);
                var value = encodeURIComponent(data[i]);
                tempArr.push(key + '=' + value);
            }
            var urlParamsStr = tempArr.join(patter);
            return urlParamsStr;
        } catch (err) {
            return '';
        }
    },

    /********
    	description：拷贝对象
    	paramter：
    		data:【必需】需拷贝的对象
    	version:1.0.0
    	data:2019/08/26
    	changeContent:基础版(cuishuai)
    ********/
    repeatObject: function repeatObject(data) {
        var repeatData = data instanceof Array ? [] : {};
        Object.assign(repeatData, data);
        return JSON.parse(JSON.stringify(repeatData));
    },

    /********
    clearSpaces：清除空格
    paramter：
    data:【必需】 要去除空格的字符串
    version:1.0.0
    changeContent:基础版(chenkailei)
    ********/
    clearSpaces: function clearSpaces(data) {
        return data ? String(data).replace(/\s/g, "") : "";
    },

    /********
    getBrowser:查询浏览器信息
    version:1.0.0
    ********/
    getBrowser: function getBrowser() {
        //rendering engines
        var engine = {
            ie: 0,
            gecko: 0,
            webkit: 0,
            khtml: 0,
            opera: 0,
            type: null,
            //complete version
            ver: null
        };
        //browsers
        var browser = {
            //browsers
            ie: 0,
            firefox: 0,
            safari: 0,
            konq: 0,
            opera: 0,
            chrome: 0,
            type: null,
            //specific version
            ver: null
        };
        //platform/device/OS
        var system = {
            win: false,
            mac: false,
            x11: false,

            winPhone: false,
            winMobile: false,
            iphone: false,
            ipod: false,
            ipad: false,
            ios: false,
            android: false,
            nokiaN: false,
            type: null
        };

        //detect rendering engines/browsers
        var ua = navigator.userAgent;
        //opera   
        if (window.opera) {
            engine.opera = browser.opera = window.opera.version();
            browser.type = "opera";
            engine.type = "opera";
        } else if (/AppleWebKit\/(\S+)/.test(ua)) {
            engine.type = "webkit";
            engine.webkit = RegExp["$1"];

            //figure out if it's Chrome or Safari
            if (/OPR\/(\S+)/.test(ua)) {
                //首先排除opera。由于在新版本中使用了webkit内核
                browser.type = "opera";
                browser.opera = RegExp["$1"];
            } else if (/Chrome\/(\S+)/.test(ua)) {
                browser.type = "chrome";
                browser.chrome = RegExp["$1"];
            } else if (/Version\/(\S+)/.test(ua)) {
                browser.type = "safari";
                browser.safari = RegExp["$1"];
            } else {
                //approximate version
                var safariVersion = 1;
                if (engine.webkit < 100) {
                    safariVersion = 1;
                } else if (engine.webkit < 312) {
                    safariVersion = 1.2;
                } else if (engine.webkit < 412) {
                    safariVersion = 1.3;
                } else {
                    safariVersion = 2;
                }
                browser.type = "safari";
                browser.safari = safariVersion;
            }
        } else if (/KHTML\/(\S+)/.test(ua) || /Konqueror\/([^;]+)/.test(ua)) {
            engine.type = "khtml";
            engine.khtml = browser.konq = RegExp["$1"];
        } else if (/rv:([^\)]+)\) Gecko\/(\d{8}|\S+)/.test(ua)) {
            // 添加了手机火狐不是8位数字的支持
            engine.type = "gecko";
            engine.gecko = RegExp["$1"];

            //determine if it's Firefox
            if (/Firefox\/(\S+)/.test(ua)) {
                browser.type = "firefox";
                browser.firefox = RegExp["$1"];
            }
        } else if (/MSIE ([^;]+)/.test(ua)) {
            //engine.ver = browser.ver = RegExp["$1"]; browser.ver =
            engine.type = browser.type = "ie";
            engine.ie = browser.ie = RegExp["$1"];
        } else if (/Trident\/([^;]+)/.test(ua)) {
            //ie11
            if (/rv:([^\)]+)\)/.test(ua)) {
                engine.type = browser.type = "ie";
                engine.ie = browser.ie = RegExp["$1"];
            }
        }

        //detect platform
        var p = navigator.platform;
        if (system.win = p.indexOf("Win") == 0) {
            system.type = "win";
            //detect windows operating systems
            if (/Win(?:dows )?([^do]{2})\s?(\d+\.\d+)?/.test(ua)) {
                if (RegExp["$1"] == "NT") {
                    switch (RegExp["$2"]) {
                        case "5.0":
                            system.win = "2000";
                            break;
                        case "5.1":
                            system.win = "XP";
                            break;
                        case "6.0":
                            system.win = "Vista";
                            break;
                        case "6.1":
                            system.win = "7";
                            break;
                        case "6.2":
                            system.win = "8";
                            break;
                        case "6.3":
                            system.win = "8.1";
                            break;
                        default:
                            system.win = "NT";
                            break;
                    }
                } else if (RegExp["$1"] == "9x") {
                    system.win = "ME";
                } else if (RegExp["$1"] == "Ph") {
                    //windows phone 7.5 and 8.0
                    system.type = "winPhone";
                    if (/Windows Phone OS (\d+.\d+)/.test(ua) || /Windows Phone (\d+.\d+)/.test(ua)) {
                        system.winPhone = RegExp["$1"];
                    }
                } else {
                    system.win = RegExp["$1"];
                }
            }

            //windows mobile
            if (system.win == "CE") {
                system.winMobile = system.win;
            } else if (system.win == "Ph") {
                if (/Windows Phone OS (\d+.\d+)/.test(ua)) {
                    ;
                    system.type = "winMobile";
                    system.winMobile = RegExp["$1"];
                }
            }
        } else if (system.x11 = p == "X11" || p.indexOf("Linux") == 0) {
            system.type = "x11";
            //determine Android version
            if (/Android (\d+\.\d+)/.test(ua)) {
                system.type = "android";
                system.android = RegExp.$1;
            }
        } else if (system.mac = p.indexOf("Mac") == 0) {
            system.type = "mac";
            //mobile devices
            if (system.iphone = ua.indexOf("iPhone") > -1) {
                system.type = "iphone";
            } else if (system.ipod = ua.indexOf("iPod") > -1) {
                system.type = "ipod";
            } else if (system.ipad = ua.indexOf("iPad") > -1) {
                system.type = "ipad";
            }

            //determine iOS version
            if (system.mac && ua.indexOf("Mobile") > -1) {
                if (/CPU (?:iPhone )?OS (\d+_\d+)/.test(ua)) {
                    system.ios = parseFloat(RegExp.$1.replace("_", "."));
                } else {
                    system.ios = 2; //can't really detect - so guess
                }
            }
        }

        //处理一些特别的情况
        if (system.nokiaN = ua.indexOf("NokiaN") > -1) {
            system.type = "nokiaN";
        } else if (/Android; Mobile/.test(ua)) {
            //安卓上火狐浏览器
            system.type = "android";
            system.android = "Not detect";
        }

        //return it
        return {
            engine: { name: engine.type, version: engine[engine.type] },
            browser: { name: browser.type, version: browser[browser.type] },
            system: { name: system.type, version: system[system.type] }
        };
    },

    /********
    updateIE:IE9提示更新
    version:1.0.0
    ********/
    updateIE: function updateIE() {
        var browserObj = this.getBrowser().browser;
        if (browserObj.name == "ie" && browserObj.version == "9.0") {
            if (confirm("为给您带来更好的服务，请下载并使用IE11浏览器，确认下载吗？")) {
                if (navigator.userAgent.indexOf("win64") >= 0 || navigator.userAgent.indexOf("wow64") >= 0) {
                    window.open("http://download.microsoft.com/download/F/2/8/F2871AC4-E82B-4636-BB37-A5F2B14C8616/IE11-Windows6.1-x86-zh-cn.exe");
                } else {
                    window.open("http://download.microsoft.com/download/5/6/F/56FD6253-CB53-4E38-94C6-74367DA2AB34/IE11-Windows6.1-x64-zh-cn.exe");
                }
            }
        }
    },

    /********
    bracketsConversion：中英文括号转换
    paramter：
            val:【必需】 要转换的字符串
            type: ZH 转为中文   EN 转为英文
    version:1.0.0
    changeContent:基础版(chenkailei)
    ********/
    bracketsConversion: function bracketsConversion(val) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ZH";

        if (type == 'ZH') {
            var _reg = /[\(W]/g,
                _reg2 = /[\)]/g;
            return val.replace(_reg, "（").replace(_reg2, "）");
        }
        if (type == 'EN') {
            var reg = /[\（]/g,
                reg2 = /[\）]/g;
            return val.replace(reg, "(").replace(reg2, ")");;
        }
    }
};